import { SyntheticEvent } from "react";
import { Box, Tab, Tabs } from "@mui/material";

type ClinicSettingsTabKey = "clinic" | "ourMedicalApp" | "doctorsApp" | "saApp";

interface ClinicSettingsTabsProps {
	activeTab: ClinicSettingsTabKey;
	onTabChange: (tab: ClinicSettingsTabKey) => void;
}

const tabs: Array<{ key: ClinicSettingsTabKey; label: string }> = [
	{ key: "clinic", label: "Clinic" },
	{ key: "ourMedicalApp", label: "Our Medical App" },
	{ key: "doctorsApp", label: "Doctors App" },
	{ key: "saApp", label: "Services Australia" }
];

export const ClinicSettingsTabs = ({
	activeTab,
	onTabChange
}: ClinicSettingsTabsProps) => {
	const activeIndex = tabs.findIndex((tab) => tab.key === activeTab);

	const handleTabChange = (_event: SyntheticEvent, newValue: number) => {
		onTabChange(tabs[newValue].key);
	};

	return (
		<Box
			sx={{
				borderBottom: 1,
				borderColor: "divider",
				marginBottom: 4,
				width: "fit-content"
			}}
		>
			<Tabs
				value={activeIndex}
				onChange={handleTabChange}
				aria-label="Clinic settings tabs"
			>
				{tabs.map((tab) => (
					<Tab key={tab.key} label={tab.label} />
				))}
			</Tabs>
		</Box>
	);
};

export type { ClinicSettingsTabKey };
